<template lang="pug">
    el-footer(style="height: 40px")
      p ©2018 Manhattan Code inc.
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
  .el-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 768px) {
      height: 40px !important;
    }
    @media screen and (min-width: 1200px) {
      height: 60px !important;
    }
    > p {
      font-size: 0.8rem;
      @media screen and (min-width: 768px) {
        font-size: 1.0rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue